import script from "./PopupDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupDialog.vue?vue&type=script&setup=true&lang=js"

import "./PopupDialog.vue?vue&type=style&index=0&id=659042f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659042f8"]])

export default __exports__